import axios from "axios";
import { useEffect, useState } from "react";

const BASE = process.env.REACT_APP_BACKEND_URL;
const API = BASE ? `${BASE}/api` : "";

export type Faq = { id?: string; question: string; answer: string };
export type Story = {
  id: string;
  name: string;
  headline: string;
  quote: string;
  result_range?: string;
  duration?: string;
  before_url?: string;
  after_url?: string;
};
export type LeadInput = { name: string; phone: string; email: string; goal: string; source_page: string };

export async function createLead(data: LeadInput) {
  if (!API) throw new Error("Booking is unavailable right now");
  const res = await axios.post(`${API}/leads`, data);
  return res.data;
}

export function useList<T>(path: string, fallback: T[] = []) {
  const [items, setItems] = useState<T[]>(fallback);
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    let alive = true;
    if (!API) {
      setLoaded(true);
      return () => { alive = false; };
    }
    axios
      .get(`${API}${path}`)
      .then((r) => { if (alive && Array.isArray(r.data)) setItems(r.data); })
      .catch(() => {})
      .finally(() => { if (alive) setLoaded(true); });
    return () => { alive = false; };
  }, [path]);
  return { items, loaded };
}
